import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import braUfCities from '../../../assets/json/braUfCities.json';
import { useToast } from '../../../context/ToastContext';
import { usePurchase } from '../../../context/PurchaseContext';

const Purchase = () => {
  const { planId } = useParams();
  const { addToast } = useToast();
  const navigate = useNavigate();
  const { purchase, updatePurchase } = usePurchase();
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    cpf: '',
    phone: '',
    cep: '',
    state: '',
    city: '',
    address: '',
  });

  useEffect(() => {
    if (purchase) {
      formData.name = purchase.name;
      formData.email = purchase.email;
      formData.cpf = purchase.cpf;
      formData.phone = purchase.phone;
      formData.cep = purchase.cep;
      formData.state = purchase.state;
      formData.city = purchase.city;
      formData.address = purchase.address;
    }
  }, [purchase]);

  useEffect(() => {
    if (formData.state) {
      const state = braUfCities.find(uf => uf.sigla === formData.state);
      setCities(state ? state.cidades : []);
    } else {
      setCities([]);
    }
  }, [formData.state]);


  const planName = (planId) => {
    if (parseInt(planId) === 1) {
      return 'MENSAL';
    } else if (parseInt(planId) === 2) {
      return 'ANUAL (Á Vista)';
    } else {
      return 'ANUAL (Parcelado)';
    }
  }

  const planPrice = (planId) => {
    if (parseInt(planId) === 1) {
      return <div><i className="bi bi-award"></i> R$ 190,00</div>;
    } else if (parseInt(planId) === 2) {
      return <div><i className="bi bi-award-fill"></i> R$ 1.080,00</div>;
    } else {
      return <div><i className="bi bi-trophy-fill"></i> 4 x R$ 310,00</div>;
    }
  }

  const handlePurchase = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      cpf: formData.get('cpf'),
      phone: formData.get('phone'),
      cep: formData.get('cep'),
      state: formData.get('state'),
      city: formData.get('city'),
      address: formData.get('address'),
      planId: planId,
    }

    if (data.name === '' || data.email === '' || data.cpf === '' || data.phone === '' || data.cep === '' || data.state === '' || data.city === '' || data.address === '') {
      addToast('Preencha todos os campos.');
      return;
    }
    if (data.cpf.length !== 11) {
      addToast('CPF inválido.');
      return;
    }
    if (data.phone.length !== 11) {
      addToast('Telefone inválido. Digite o DDD + 9 dígitos.');
      return;
    }
    if (data.cep.length !== 8) {
      addToast('CEP inválido.');
      return;
    }
    if (!data.state || data.state === '0') {
      addToast('Selecione um estado.');
      return;
    }
    if (!data.city || data.city === '0') {
      addToast('Selecione uma cidade.');
      return;
    }

    updatePurchase(data);
    navigate('/main/payment');
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      {planId && (
        <Container className="">
          <Row>
            <Col md={4}>
              <Card>
                <Card.Header className="bg-secondary text-white">{planName(planId)}</Card.Header>
                <Card.Body>
                  <Card.Text as="div">
                    <h2> {planPrice(planId)}</h2>
                    <hr />
                    <div>Acesso às bases de dados de insumos e serviços da construção civil de forma organizada, completa, íntegra e com consistência técnica por <b>30 dias</b>.</div>
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <Button size="sm" variant="outline-secondary" href="/main/plans">VOLTAR</Button>
                </Card.Footer>
              </Card>
            </Col>

            <Col md={8}>
              <Form onSubmit={handlePurchase}>
                <Card>
                  <Card.Header className="bg-secondary text-white">DADOS DE PAGAMENTO. ETAPA 1 / 2</Card.Header>
                  <Card.Body>
                    <Card.Text as="div">
                      <Form.Group className="mb-1">
                        <Form.Label>Nome:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='name'
                          required
                          onChange={handleInputChange}
                          value={formData.name}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Email:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="email"
                          name='email'
                          required
                          onChange={handleInputChange}
                          value={formData.email}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>CPF:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='cpf'
                          required
                          onChange={handleInputChange}
                          value={formData.cpf}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Telefone (DDD + 9 dígitos):</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='phone'
                          required
                          onChange={handleInputChange}
                          value={formData.phone}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>CEP:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='cep'
                          required
                          onChange={handleInputChange}
                          value={formData.cep}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Estado:</Form.Label>
                        <Form.Select
                          size='sm'
                          name='state'
                          onChange={handleInputChange}
                          value={formData.state}
                        >
                          {braUfCities.map((uf, index) => (
                            <option key={uf.sigla} value={uf.sigla}>{uf.sigla + '/' + uf.nome}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Cidade:</Form.Label>
                        <Form.Select
                          size='sm'
                          name='city'
                          onChange={handleInputChange}
                          value={formData.city}
                        >
                          {cities.map((city, index) => (
                            <option key={index} value={city}>{city}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Endereço:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='address'
                          required
                          onChange={handleInputChange}
                          value={formData.address}
                        />
                      </Form.Group>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <Button variant="primary" type='submit'>PRÓXIMO</Button>
                  </Card.Footer>
                </Card>

              </Form>
            </Col>

          </Row>
        </Container>
      )}
    </>
  );
};

export default Purchase